import React from 'react';
import HighlightedCode from "../comp/HighlightedCode";
import { BlockMatchSnippetDto } from "../common/dto/BlockMatchSnippetDto";

type Props = {
    snippet: BlockMatchSnippetDto
}

function* range(from: number, to: number): Generator {
    for (let i = from; i < to; i++) {
        yield i;
    }
}

const CodeMatchSnippet = (props: Props) => {

    const lineNumbers: string[] = Array.from(
        range(props.snippet.lineStart, props.snippet.lineEnd + 1)) as string[];

    const style = (snippet: BlockMatchSnippetDto, ln) => {
        return ln >= snippet.lineMarkedStart && ln <= snippet.lineMarkedEnd
            ? 'source-row-number-link-error'
            : '';
    };

    return (
        <div className="review-code-block mt-3">

            <div className="source-container">
                <div className="source-row-numbers">
                    { lineNumbers.map(ln => <div
                        className={ style(props.snippet, ln) }
                        key={ln}>{ln}<br /></div>) }
                </div>
                <div>
                    <HighlightedCode fileContents={ props.snippet.fileContents }
                                     fileName={ props.snippet.filePath } />
                </div>
            </div>

            <hr />

        </div>
        );
};

export default CodeMatchSnippet;
